import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const allowedEmailDomains = ['crossworkers.com'] as const;

function getCurrentUserEmail(): string | null {
  try {
    const raw = localStorage.getItem('currentUser');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return (parsed?.user?.email ?? null) as string | null;
  } catch {
    return null;
  }
}

export function isAllowedDomainEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const trimmed = email.trim().toLowerCase();
  const atIndex = trimmed.lastIndexOf('@');
  if (atIndex < 0) return false;
  const domain = trimmed.slice(atIndex + 1);
  return allowedEmailDomains.some((d) => domain === d);
}

export const emailDomainGuard: CanActivateFn = () => {
  const router = inject(Router);
  const email = getCurrentUserEmail();

  if (!isAllowedDomainEmail(email)) {
    router.navigate(['/reports']);
    return false;
  }

  return true;
};

